// extracted by mini-css-extract-plugin
module.exports = {"chapter":"Chapter_chapter__rQGBQ","opacity-0":"Chapter_opacity-0__3_pEq","opacity-1":"Chapter_opacity-1__1EMJW"};